import React from "react";
import { DRAWING_TOOL } from "../../../engine/drawings/drawingTools";

const VIEW_BOX = "0 0 24 24";
const STROKE_WIDTH = 1.5;
const HANDLE_RADIUS = 2;

const SHAPES = {
  [DRAWING_TOOL.HORIZONTAL_LINE]: (
    <>
      <path d="M2 12h8M14 12h8" />
      <circle cx="12" cy="12" r={HANDLE_RADIUS} />
    </>
  ),
  [DRAWING_TOOL.VERTICAL_LINE]: (
    <>
      <path d="M12 2v8M12 14v8" />
      <circle cx="12" cy="12" r={HANDLE_RADIUS} />
    </>
  ),
  [DRAWING_TOOL.RAY]: (
    <>
      <circle cx="5" cy="19" r={HANDLE_RADIUS} />
      <path d="M6.5 17.5L22 2" />
    </>
  ),
  [DRAWING_TOOL.TREND_LINE]: (
    <>
      <circle cx="5" cy="19" r={HANDLE_RADIUS} />
      <circle cx="19" cy="5" r={HANDLE_RADIUS} />
      <path d="M6.5 17.5l11-11" />
    </>
  ),
  [DRAWING_TOOL.RECTANGLE]: (
    <>
      <rect x="4" y="6" width="16" height="12" />
      <circle cx="4" cy="18" r={HANDLE_RADIUS} fill="currentColor" />
      <circle cx="20" cy="6" r={HANDLE_RADIUS} fill="currentColor" />
    </>
  ),
  [DRAWING_TOOL.FIBONACCI_RETRACEMENT]: (
    <>
      <path d="M3 5h18M3 10h18M3 14h18M3 19h18" />
      <circle cx="19" cy="5" r={HANDLE_RADIUS} fill="currentColor" />
      <circle cx="5" cy="19" r={HANDLE_RADIUS} fill="currentColor" />
    </>
  ),
  [DRAWING_TOOL.FIBONACCI_FAN]: (
    <>
      <circle cx="4" cy="20" r={HANDLE_RADIUS} />
      <path d="M5.5 18.5L18 2M6 19l16-11M6 20h16" />
    </>
  ),
  [DRAWING_TOOL.PARALLEL_CHANNEL]: (
    <>
      <path d="M3 14L15 3M9 21L21 10" />
      <circle cx="3" cy="14" r={HANDLE_RADIUS} fill="currentColor" />
      <circle cx="21" cy="10" r={HANDLE_RADIUS} fill="currentColor" />
    </>
  ),
  [DRAWING_TOOL.ANDREWS_PITCHFORK]: (
    <>
      <circle cx="4" cy="20" r={HANDLE_RADIUS} />
      <path d="M5.5 18.5L21 3M8 8l13-5M16 16l5-13M8 8l8 8" />
    </>
  ),
};

/**
 * Icon of a drawing tool, in the lucide style: stroke-based, uses currentColor.
 *
 * @param {object} props
 * @param {string} props.toolId - DRAWING_TOOL value
 * @param {number} props.size   - width and height in px
 */
const DrawingToolIcon = ({ toolId, size }) => (
  <svg
    width={size}
    height={size}
    viewBox={VIEW_BOX}
    fill="none"
    stroke="currentColor"
    strokeWidth={STROKE_WIDTH}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    {SHAPES[toolId]}
  </svg>
);

export default DrawingToolIcon;
